export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ06A.d320a077.mp3";